<template>
  <div id="contactWrapper">
    <div id="contact-form" class="contact-form">
      <h1 class="contact-form_title">Contact Us</h1>
      <div class="separator"></div>

      <div v-if="isSending" class="loading">Sending...</div>

      <form class="form" @submit.prevent="onSubmit">
        <input
          required
          name="name"
          v-model="name"
          placeholder="Name"
          type="text"
          autocomplete="off"
        />
        <input
          required
          name="email"
          v-model="email"
          placeholder="E-mail"
          type="email"
          autocomplete="off"
        />
        <textarea name="message" v-model="message" rows="4" placeholder="Message"></textarea>
        <button class="button">Send</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onSubmit () {
      const formData = {
        name: this.name,
        email: this.email,
        message: this.message
      }
      this.$store
        .dispatch('submit', {
          name: formData.name,
          email: formData.email,
          message: formData.message
        })
        .then(response => {
          this.$router.push({ name: 'Home' })
        })
    }
  }
}
</script>

<style scoped>
#contactWrapper {
  position: relative;
  background-color: white;
  min-height: calc(100vh - 50px);
  margin: 0 auto;
}

.contact-form {
  position: relative;
  top: 200px;
  font-family: 16px;
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
  background-color: #f2f2f2;
  padding: 50px;
  box-shadow: 2px 2px 2px gray;
}

.contact-form .separator {
  border-bottom: solid 1px #ccc;
  margin-bottom: 15px;
}

.contact-form .form {
  display: flex;
  flex-direction: column;
  font-size: 16px;
}

.contact-form_title {
  color: #333;
  text-align: left;
  font-size: 28px;
  padding-left: 20px;
}

.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea {
  border: solid 1px #e8e8e8;
  font-family: "Roboto", sans-serif;
  padding: 10px 7px;
  margin-bottom: 15px;
  outline: none;
}

.contact-form textarea {
  resize: none;
}

.contact-form .button {
  background: #da552f;
  border: solid 1px #da552f;
  color: white;
  cursor: pointer;
  padding: 10px 50px;
  text-align: center;
  text-transform: uppercase;
}

.contact-form .button:hover {
  background: #ea532a;
  border: solid 1px #ea532a;
}

.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea,
.contact-form .button {
  font-size: 15px;
  border-radius: 3px;
}

@media screen and (max-width: 600px) {
  #contactWrapper {
    background-color: #f2f2f2;
  }
  .contact-form {
    padding-left: 0;
    padding-right: 0;
    box-shadow: none;
  }

  .contact-form > form > input,
  .contact-form > form > textarea,
  .contact-form > form > button {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
